import { render, staticRenderFns } from "./PlayerOrders.vue?vue&type=template&id=1fa7231f&"
import script from "./PlayerOrders.vue?vue&type=script&lang=js&"
export * from "./PlayerOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports